<template>
  <base-section
    id="loan-estimate"
    class="text-center"
  >
    <div />
    <v-container>
      <v-row
        justify="center"
      >
        <v-col
          cols="12"
          md="3"
        >
          <div>
            <base-info-card
              :title="title"
              :subtitle="subTitle"
              space="4"
              color="primary"
            />
            <v-form>
              <v-text-field
                v-model="loanConfiguration.loanAmountBase"
                v-money="money"
                :error-messages="loanAmountBaseErrors"
                label="Desired Loan Amount"
                required
                append-icon="mdi-arrow-right-circle"
                @click:append="debounceInput"
                @keydown.enter.prevent="debounceInput"
              />
            </v-form>
          </div>
        </v-col>
      </v-row>
      <v-row
        justify="center"
      >
        <v-col
          v-for="(plan, i) in plans"
          :key="i"
          cols="12"
          md="4"
        >
          <price-card v-bind="plan" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import Finance from 'financejs'
  import _ from 'lodash'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'SectionLoanComparison',
    components: {
      PriceCard: () => import('@/components/LoanComparisonCard'),
    },

    mixins: [validationMixin],
    validations: {
      loanConfiguration: {
        loanAmountBase: { required },
      },
    },
    provide: {
      heading: { align: 'center' },
    },
    data: () => ({
      money: {
        prefix: '$ ',
        precision: 0,
      },
      title: 'Compare',
      subTitle: 'Find out if the HEQ loan is right for you',
      loanConfiguration: {
        term: 30,
        otherTerm: 30,
        deferredYears: 5,
        rate: 2,
        otherRate: 3.75,
        otherMonthlyPayment: 0,
        loanAmountBase: 0,
      },
      deferredYearsLabels: [1, 2, 3, 4, 5],
      internalPlans: [
        {
          title: 'HEQ Loan',
          subtitle: 'HEQ - Flexible, Stable and Secure',
          value: true,
          link: true,
          totalSavings: 0,
          features: [
            '2% Fixed Rate',
            'No payment for up to 5 years',
            '30 Year Loan',
          ],
        },
        {
          title: 'The Other Guys',
          subtitle: 'Square peg in a round hole',
          value: false,
          link: false,
          totalSavings: 0,
          features: [
            'Current Market Rate Fixed 3.75%',
            'Don\'t even think about skipping a payment',
            '30 Year Loan',
          ],
        },
      ],
      interval: 0,
    }),

    computed: {
      loanAmountBase () {
        return this.convertCurrencyToInt(this.loanConfiguration.loanAmountBase)
      },
      plans () {
        return this.internalPlans.map(plan => {
          return {
            ...plan,
            features: plan.features,
            title: plan.title,
            subtitle: plan.subtitle,
            totalSavings: plan.totalSavings,
          }
        })
      },
      loanAmountBaseErrors () {
        const errors = []
        if (!this.$v.loanConfiguration.loanAmountBase.$dirty) return errors
        !this.$v.loanConfiguration.loanAmountBase.required && errors.push('Loan Amount Base is required.')
        return errors
      },
    },
    beforeMount () {
      this.calculateAll()
    },

    methods: {
      calculateAll () {
        this.calculateTheOtherGuys()
        this.calculateHeqPlus()
      },
      calculateTheOtherGuys () {
        const finance = new Finance.Finance()
        this.loanConfiguration.otherMonthlyPayment = Math.round(finance.AM(this.loanAmountBase, this.loanConfiguration.otherRate, this.loanConfiguration.otherTerm, 0))
      },

      calculateHeqPlus () {
        const finance = new Finance.Finance()
        const prePaidInterest = this.loanAmountBase * (this.loanConfiguration.deferredYears * 2 / 100)
        const loanAmount = prePaidInterest + parseInt(this.loanAmountBase)
        const term = this.loanConfiguration.term - this.loanConfiguration.deferredYears
        const monthlyPayment = Math.round(finance.AM(loanAmount, this.loanConfiguration.rate, term, 0))
        const deferralSavings = monthlyPayment * this.loanConfiguration.deferredYears * 12
        this.internalPlans[0].totalSavings = Math.round((this.loanConfiguration.otherMonthlyPayment * 30 * 12 - monthlyPayment * term * 12) + deferralSavings)
      },

      convertCurrencyToInt (val) {
        console.log('val', val, typeof val)
        const type = typeof val
        if (type === 'string') {
          return parseInt(val.replace(/\$/g, '').replace(/ /g, '').replace(/,/g, ''))
        } else if (type === 'number') {
          return val
        } else {
          return 0
        }
      },
      calculateMonths (finAmount, finInterest, finPayment) {
        var result = 0

        if (finInterest === 0) {
          result = Math.ceil(finAmount / finPayment)
        } else {
          result = Math.round(((-1 / 12) * (Math.log(1 - (finAmount / finPayment) * ((finInterest / 100) / 12))) / Math.log(1 + ((finInterest / 100) / 12))) * 12)
        }

        return result
      },
      numberWithCommas (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },

      debounceInput: _.debounce(function () {
        this.$v.loanConfiguration.loanAmountBase.$touch()
        this.calculateAll()
      }, 1000),

    },
  }
</script>
